import React from "react";
import { useField } from "formik";

interface myProps {
  label: string;
  type: string;
  placeholder: string;
  name: string;
  id: string;
  className?: string;
  required?: boolean;
}
const MyTextField: React.FC<myProps> = ({
  label,
  className,
  required,
  ...props
}) => {
  const [field, meta] = useField(props);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    window.dataLayer?.push({
      event: "input_change",
      fieldName: props.name,
    });
    field.onChange(e); // Keep Formik functionality
  };
  return (
    <>
      <label
        className="font-medium text-base mt-3 "
        htmlFor={props.id || props.name}
      >
        {label} {required && <span className="text-red-500 text-lg">*</span>}
      </label>
      <input
        className={` ${className}  ${
          meta.touched && meta.error ? "border-red-500" : "border-[#E2E5EA]"
        }  border rounded-lg border-[#E2E5EA] py-2 px-2 focus:border-[#E2E5EA] border-solid`}
        {...field}
        {...props}
        value={field.value || ""}
        onChange={handleChange}
      />
      {meta.touched && meta.error ? (
        <div className="error text-red-400">{meta.error}</div>
      ) : null}
    </>
  );
};

export default MyTextField;
